import { GraphQLFieldConfig, GraphQLNonNull, GraphQLList } from 'graphql'
import { Context } from '../shared'
import { ModuleType, Module } from '../types/module'
import {
  applicationQueryArgs,
  ApplicationQueryArgs
} from '../types/application-query-args'

function normalizeModule({ app_id: id, name }) {
  return {
    id,
    name
  }
}

export const applicationModules: GraphQLFieldConfig<
  any,
  Context,
  ApplicationQueryArgs
> = {
  description: 'Get an application by ID and Organization ID',
  type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(ModuleType))),
  args: applicationQueryArgs,
  async resolve(_source, args, context): Promise<Module[]> {
    const { organizationID, applicationID } = args

    const {
      application: { modules }
    } = await context.connector.get(
      `/${organizationID}/applications/${applicationID}?expand=modules`
    )

    return modules.map(normalizeModule)
  }
}
